import axios, { AxiosResponse } from 'axios'

import { Response } from '@models/apiBase'
import { FileModel } from '@models/file'
import { NRICCardOCRModel } from '@models/nricCardOcr'

import { API_URL } from '@/constants/constant'

type ResponseNRICCard = Response<{
  file: FileModel
  nric_card: NRICCardOCRModel
}>

type ResponseNRICCardUpload = Response<{
  file: FileModel
}>

interface INRICCardOCRAPI {
  extract: (image: File) => Promise<ResponseNRICCard>

  upload: (
    image: File,
    onUploadProgress?: (ProgressEvent: ProgressEvent) => void,
    controller?: AbortController
  ) => Promise<ResponseNRICCardUpload>
}

const NRIC_CARD_OCR_API_URL = `${API_URL}/nric-card-ocr`

const NRICCardOCRAPI: INRICCardOCRAPI = {
  extract: async (image: File) => {
    const formData = new FormData()
    formData.append('image', image)

    return axios
      .post(`${NRIC_CARD_OCR_API_URL}/extract`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data)
  },

  upload: async (image, onUploadProgress, controller) => {
    var bodyFormData = new FormData()
    bodyFormData.append('image', image)

    return axios
      .post(`${NRIC_CARD_OCR_API_URL}/upload`, bodyFormData, {
        signal: controller?.signal,
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: onUploadProgress,
      })
      .then((r: AxiosResponse) => r.data)
  },
}

export { NRICCardOCRAPI }
